import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const addAssignment = (assignment) => {
    const formData = convertModelToFormData(assignment);
    if (assignment.projectTaskNumbers?.length) {
        formData.append('projectTaskNumbersJson', JSON.stringify(assignment.projectTaskNumbers));
    }
    return qportalApi.postForm(`Assignment`, formData);
};
const getAssignments = () => {
    return qportalApi.get(`Assignment/getFreelancerAssignments`);
};
const getAssignmentsByStatus = (status) => {
    return qportalApi.get(`Assignment/${status}/getFreelancerAssignmentByContractStatus`);
};
const getAssignmentsWithApprovedTimeSheet = () => {
    return qportalApi.get(`Assignment/GetFreelancerAssignmentByApprovedTimeSheet`);
};
const getAssignmentsByStatusWithReason = (status) => {
    return qportalApi.get(`Assignment/${status}/GetFreelancerAssignmentByContractStatusWithReason`);
};
const getAssignmentById = (Id) => {
    return qportalApi.get(`Assignment/${Id}/GetAssignmentById`);
};
const getAssignmentDetailById = (AssignmentId) => {
    return qportalApi.get(`Assignment/${AssignmentId}/getCurrentAssignmentDetail`);
};
const updateAssignment = (assignment) => {
    const formData = convertModelToFormData(assignment);
    if (assignment.projectTaskNumbers?.length) {
        formData.append('projectTaskNumbersJson', JSON.stringify(assignment.projectTaskNumbers));
    }
    return qportalApi.postForm(`Assignment/UpdateAssignment`, formData);
};
const updateAssignmentContract = (assignment) => {
    const formData = convertModelToFormData(assignment);
    return qportalApi.postForm('Assignment/updateAssignmentContract', formData);
};
const updateAssignmentContractEndDate = (assignment) => {
    const formData = convertModelToFormData(assignment);
    return qportalApi.postForm('Assignment/updateAssignmentContractEndDate', formData);
};
const generateAutoContract = (assignment) => {
    const formData = convertModelToFormData(assignment);
    if (assignment.projectTaskNumbers?.length) {
        formData.append('projectTaskNumbersJson', JSON.stringify(assignment.projectTaskNumbers));
    }
    return qportalApi.post('Assignment/GenerateAutoContract', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateAssignmentArchiveStatus = (assignmentId, isArchived) => {
    return qportalApi.post(`Assignment/UpdateArchiveStatus`, { assignmentId, isArchived });
};
const previewContract = async (htmlContent, fileName = 'contract_preview.pdf') => {
    const response = await qportalApi.post('Assignment/PreviewContract', { htmlContent, fileName }, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};
const AssignmentApi = {
    addAssignment,
    getAssignments,
    getAssignmentById,
    getAssignmentsByStatus,
    getAssignmentDetailById,
    updateAssignment,
    updateAssignmentContract,
    getAssignmentsByStatusWithReason,
    getAssignmentsWithApprovedTimeSheet,
    updateAssignmentContractEndDate,
    generateAutoContract,
    previewContract,
    updateAssignmentArchiveStatus
};
export default AssignmentApi;
